import React, { Component } from "react";
import { Div, Button, Text, Image, Icon } from "atomize";

class PrimaryButton extends React.Component {
  constructor(props) {
    super(props);
  }

  render() {
    const { children, textSize, ...rest } = this.props;
    return (
      <Button {...rest}>
        <Text textSize={textSize} style={{ lineHeight: "initial" }}>
          {children}
        </Text>
      </Button>
    );
  }
}

PrimaryButton.defaultProps = {
  bg: "rgba(255, 255, 255, 0.15)",
  hoverBg: "rgba(255, 255, 255, 0.5)",
  border: "1px solid",
  borderColor: "rgba(255, 255, 255, 0.5)",
  textColor: "white",
  textWeight: "600",
  rounded: "xs",
  fontFamily: "primary",
  p: { x: { xs: "0.75rem", sm: "1rem" } },
  textTransform: "uppercase",
};

export default PrimaryButton;
